import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { MakeApiCallSynchronous, MakeApiCallAsync } from '../../../helpers/ApiHelpers';
import Config from '../../../helpers/Config';
import { getRelevantFilterOptions } from '../../../helpers/ProductFilterOptions';
import "../../resources/themeContent/images/img2.jpg"

import { useSelector, useDispatch } from 'react-redux';
import rootAction from '../../../stateManagment/actions/rootAction';
import { LOADER_DURATION } from '../../../helpers/Constants';
import { makeAnyStringLengthShort, makeProductShortDescription, replaceWhiteSpacesWithDashSymbolInUrl } from '../../../helpers/ConversionHelper';
import { GetDefaultCurrencySymbol, getLanguageCodeFromSession, GetLocalizationControlsJsonDataForScreen, replaceLoclizationLabel } from '../../../helpers/CommonHelper';
import GlobalEnums from '../../../helpers/GlobalEnums';
import { filterProductsByDeliveryLocation } from '../../../helpers/LocationHelper';


export const SiteLeftSidebarFilter = (props) => {
    const [catalogue, setCatalogue] = useState({categories: [], brands: [], sizes: [], tags: []});
    const [collapsed, setCollapsed] = useState({});
    const [selected, setSelected] = useState({});
    const langCode = getLanguageCodeFromSession();
    useEffect(() => {
        let mounted = true;
        const load = async () => {
            const endpoints = ['GET_CATEGORIES_LIST', 'GET_MANUFACTURER_LIST', 'GET_SIZE_LIST', 'GET_TAGS_LIST'];
            const responses = await Promise.all(endpoints.map(key => MakeApiCallAsync(Config.END_POINT_NAMES[key], null,
                {requestParameters: {PageNo: 1, PageSize: 1000, recordValueJson: '[]'}},
                {Accept: 'application/json', 'Content-Type': 'application/json'}, 'POST', true)));
            const lists = responses.map(response => response?.data?.data ? JSON.parse(response.data.data) : []);
            if (mounted) setCatalogue({categories: lists[0], brands: lists[1], sizes: lists[2], tags: lists[3]});
        };
        load().catch(console.error);
        return () => { mounted = false; };
    }, []);
    useEffect(() => setSelected({}), [props.searchTerm, props.routeCategoryId]);
    const options = useMemo(() => getRelevantFilterOptions(props.filterProducts || [], catalogue.categories, catalogue.brands, catalogue.sizes, catalogue.tags, GetDefaultCurrencySymbol()), [props.filterProducts, catalogue]);
    const name = (item, fallback) => langCode === Config.LANG_CODES_ENUM.Arabic
        ? item.LocalizationJsonData?.find?.(value => value.langId === Config.LANG_CODES_IDS_ENUM.Arabic)?.text || fallback : fallback;
    const sections = [
        {type: 'category', title: 'Main categories', items: options.categories.map(item => ({id: item.CategoryID, name: name(item, item.Name)}))},
        {type: 'brand', title: 'Brands', items: options.brands.map(item => ({id: item.ManufacturerID, name: item.Name}))},
        {type: 'size', title: 'Size', items: options.sizes.map(item => ({id: item.SizeID, name: name(item, item.ShortName)}))},
        {type: 'price', title: 'Price', items: options.prices},
        {type: 'rating', title: 'Rating', items: options.ratings.map(value => ({id: value, name: value + ' stars & above'}))},
        {type: 'tag', title: 'Tags', items: options.tags.map(item => ({id: item.TagID, name: name(item, item.TagName)}))}
    ];
    return <div className={props.RowColCssCls}>
        <div className="woocommerce-sidebar-area">
            {props.filtersLoading ? <p>Loading filters...</p> : sections.filter(section => section.items.length > 0).map(section =>
                <div className={`collapse-widget collections-list-widget ${collapsed[section.type] ? '' : 'open'}`} key={section.type}>
                    <h3 className={`collapse-widget-title ${collapsed[section.type] ? '' : 'active'}`}>
                        <button type="button" aria-expanded={!collapsed[section.type]} onClick={() => setCollapsed({...collapsed, [section.type]: !collapsed[section.type]})}
                            style={{background: 'none', border: 0, color: 'inherit', font: 'inherit', padding: 0, textAlign: 'left', width: '100%', cursor: 'pointer'}}>
                            {section.title} <i className="fas fa-angle-up" aria-hidden="true" />
                        </button>
                    </h3>
                    {!collapsed[section.type] && <ul className="collections-list-row">
                        {section.items.map(item => <li key={item.id} className={String(selected[section.type]) === String(item.id) ? 'active' : undefined}>
                            <Link to="#" onClick={event => {
                                props.setFilterValueInParent(event, item.id, section.type);
                                setSelected({...selected, [section.type]: item.id});
                            }}>{item.name}</Link>
                        </li>)}
                    </ul>}
                </div>
            )}
            {!props.filtersLoading && !sections.some(section => section.items.length) && <p>No related filter options.</p>}
        </div>
    </div>;
};

export const LeftSideBarPopularProducts = () => {
    const dispatch = useDispatch();

    const [PopularProductsList, setPopularProductsList] = useState([]);
    const [adminPanelBaseURL, setBaseUrl] = useState(Config['ADMIN_BASE_URL']);
    const [LocalizationLabelsArray, setLocalizationLabelsArray] = useState([]);

    const GetPopularProductsForLeftSideBar = async () => {


        const headersPouplarProducts = {
            // customerid: userData?.UserID,
            // customeremail: userData.EmailAddress,
            Accept: 'application/json',
            'Content-Type': 'application/json',

        }


        const pageSize = 200;
        const matchingProducts = [];
        let pageNo = 1;
        let totalRecords = pageSize;

        while (matchingProducts.length < 10 && (pageNo - 1) * pageSize < totalRecords) {
            const paramPouplarProducts = {
                requestParameters: {
                    PageNo: pageNo,
                    PageSize: pageSize,
                    recordValueJson: "[]",
                },
            };
            const responsePopularProducts = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_POPULAR_PRODUCTS_LIST'], null, paramPouplarProducts, headersPouplarProducts, "POST", true);
            if (responsePopularProducts == null || responsePopularProducts.data == null || !responsePopularProducts.data.data) break;

            const pageProducts = JSON.parse(responsePopularProducts.data.data);
            if (!pageProducts.length) break;
            totalRecords = parseInt(pageProducts[0]?.TotalRecords ?? pageProducts.length);
            matchingProducts.push(...filterProductsByDeliveryLocation(pageProducts));
            pageNo += 1;
        }

        await setPopularProductsList(matchingProducts.slice(0, 10));
    }


    useEffect(() => {

        const GetFiltersAllValues = async () => {

            //--get popular products list
            await GetPopularProductsForLeftSideBar();

            //-- Get website localization data
            let arryRespLocalization = await GetLocalizationControlsJsonDataForScreen(GlobalEnums.Entities["SiteLeftSidebarFilter"], null);
            if (arryRespLocalization != null && arryRespLocalization != undefined && arryRespLocalization.length > 0) {
                await setLocalizationLabelsArray(arryRespLocalization);
            }

        }

        //--start loader
        dispatch(rootAction.commonAction.setLoading(true));

        // call the function
        GetFiltersAllValues().catch(console.error);

        //--stop loader
        setTimeout(() => {
            dispatch(rootAction.commonAction.setLoading(false));
        }, LOADER_DURATION);
    }, [])



    return (

        <>
            <div className="collapse-widget aside-products-widget">
                <h3 className="aside-widget-title" id="lbl_lftfilt_pop_prod">
                    {LocalizationLabelsArray.length > 0 ?
                        replaceLoclizationLabel(LocalizationLabelsArray, "Popular Products", "lbl_lftfilt_pop_prod")
                        :
                        "Popular Products"
                    }
                </h3>



                {
                    PopularProductsList?.map((item, idx) =>

                        <div className="aside-single-products">
                            <div className="products-image">
                                <Link to="#">


                                    {
                                        item?.ProductImagesJson?.slice(0, 1).map((img, imgIdx) =>
                                            <>
                                                <img src={adminPanelBaseURL + img.AttachmentURL} alt="image" />

                                            </>

                                        )
                                    }

                                </Link>
                            </div>

                            <div className="products-content">
                                {/* <span>
                                    <Link to="#">
                                        Men's
                                    </Link>
                                </span> */}
                                <h3>
                                    <Link
                                        to={`/${getLanguageCodeFromSession()}/product-detail/${item.ProductId}/${replaceWhiteSpacesWithDashSymbolInUrl(item.CategoryName) ?? "shop"}/${replaceWhiteSpacesWithDashSymbolInUrl(item.ProductName)}`}
                                    >
                                        {makeProductShortDescription(item.ProductName, 45)}
                                    </Link>
                                </h3>

                                <div className="product-price">
                                    <span className="new-price">


                                        {item.DiscountedPrice != undefined && item.DiscountedPrice > 0 ?
                                            <>
                                                <del style={{ color: "#9494b9" }}>{GetDefaultCurrencySymbol()}{item.Price}</del> &nbsp; {GetDefaultCurrencySymbol()}{item.DiscountedPrice}
                                            </>
                                            :
                                            <>
                                                {GetDefaultCurrencySymbol()}{item.Price}
                                            </>

                                        }

                                    </span>
                                    {/* <span className="old-price">$291.00</span> */}
                                </div>
                            </div>
                        </div>

                    )}





            </div>

        </>

    );
}
